import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caroseul',
  templateUrl: './caroseul.component.html',
  styleUrls: ['./caroseul.component.css']
})
export class CaroseulComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
